export default __webpack_public_path__ + "locales/uk-UA/JavascriptSdk.json?hash=48fce45b1563569977d5822832a572ed";